import React from 'react';

class renderField extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      initialized: true
    }
  }

  componentWillMount() {
    if (this.props.defaultValue) {
      this.props.input.onChange(this.props.defaultValue);
    }
    this.setState({initialized: true});
  }

  componentWillUnmount() {
    this.setState({initialized: false});
  }

  // VE-7248: Prevent space key input when noWhitespace is explicitly true
  handleKeyDown = (e) => {
    if (this.props.noWhitespace === true && e.key === ' ') {
      e.preventDefault();
    }
  }

  // VE-7248: Trim whitespace from input when noWhitespace is explicitly true
  // Default behavior (noWhitespace = false or undefined): allow whitespace
  handleInputChange = (e) => {
    if (this.props.noWhitespace === true) {
      const value = e.target ? e.target.value : '';
      const trimmed = value.replace(/\s/g, '');
      if (value !== trimmed) {
        e.target.value = trimmed;
      }
      this.props.input.onChange(trimmed);
    }
  }

  render() {
    const {
      className,
      placeholder,
      input,
      type,
      id,
      disabled,
      meta: { touched, error, warning, asyncValidating },
      getRef,
      noWhitespace,
      ...rest
    } = this.props;

    if(type === 'checkbox') {
      if (this.props.callback) {
        this.props.callback(input.value)
      }
      return (
        <input
          {...input}
          {...rest}
          id={id}
          placeholder={placeholder}
          type={type}
          disabled={ !!disabled }
          ref={getRef}
          className={`${className ? className : '' } agree pretty-checkbox ${touched && error ? 'invalid' : ''} ${disabled && 'v-cursor-not-allowed'}`}
        />
      );
    }
    else if(type === 'textarea') {
      return (
        <div className={`${asyncValidating ? 'async-validating' : ''}`}>
          <textarea
            {...input}
            {...rest}
            id={id}
            placeholder={placeholder}
            type={type}
            disabled={ !!disabled }
            ref={getRef}
            className={`${className ? className : '' } ${touched && error ? 'invalid' : ''} ${disabled && 'v-cursor-not-allowed'}`}
          />
          <span className="field-validation-message">
            {touched &&
              (error && <span>{error}</span>)}
          </span>
          <span className="field-validation-message font-weight-bold font-italic text-warning">
            {touched &&
              (warning && <span>{warning}</span>)}
          </span>
        </div>
      );
    }
    else {      
      return (
        <div className={`${asyncValidating ? 'async-validating' : ''}`}>
          <input
            {...input}
            id={id}
            {...rest}
            placeholder={placeholder}
            type={type}
            disabled={ !!disabled }
            ref={getRef}
            className={`${className ? className : '' } ${touched && error ? 'invalid' : ''} ${disabled && 'v-cursor-not-allowed'}`}
            max={(type === 'date') ? "2999-12-31" : undefined}
            {...(noWhitespace === true ? { onChange: this.handleInputChange, onKeyDown: this.handleKeyDown } : {})}
          />
          <span className="field-validation-message">
            {touched &&
              (error && <span>{error}</span>)}
          </span>
          <span className="field-validation-message font-weight-bold font-italic text-warning">
            {touched &&
              (warning && <span>{warning}</span>)}
          </span>
        </div>
      );
    }
  }
}

export default renderField;
